import { useState, useEffect } from "react";
import "../../style/signature-creator.css";

const CORRECT_PASSWORD = "AAAaaa111";

export default function SignatureCreator() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const [formData, setFormData] = useState({
    name: "",
    title: "",
    phone: "",
  });

  useEffect(() => {
    const authStatus = sessionStorage.getItem("signature-creator-auth");
    if (authStatus === "true") {
      setIsAuthenticated(true);
    }
  }, []);

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    setError("");

    if (password === CORRECT_PASSWORD) {
      setIsAuthenticated(true);
      sessionStorage.setItem("signature-creator-auth", "true");
    } else {
      setError("Incorrect password. Please try again.");
      setPassword("");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const generateHTMLSignature = (includeWrapper = false, { forEmail = true } = {}) => {
    const { name, title, phone } = formData;
    const productionUrl = (
      process.env.REACT_APP_SITE_URL ||
      process.env.NEXT_PUBLIC_SITE_URL ||
      "https://www.bdaiat.com/"
    ).replace(/\/+$/, "");
    // const localUrl =
    //   typeof window !== "undefined"
    //     ? window.location.origin.replace(/\/+$/, "")
    //     : productionUrl;
    const siteUrl = forEmail ? productionUrl : "";
    const phoneImageUrl = `${siteUrl}//phone.png`;
    const locationImageUrl = `${siteUrl}//location.png`;
    const angelImageUrl = `${siteUrl}//angel.png`;
    const logoImageUrl = `${siteUrl}//logo.png`;
    const facebookImageUrl = `${siteUrl}//facebook.png`;
    const linkedinImageUrl = `${siteUrl}//linkdin.png`;
    const xImageUrl = `${siteUrl}//x.png`;
    const webImageUrl = `${siteUrl}//web.png`;
    const microsoftImageUrl = `${siteUrl}//microsoft.png`;
    const academyImageUrl = `${siteUrl}//academy.png`;
    const bannerImageUrl = `${siteUrl}//banner.png`;

    const phoneForJS = phone
      ? phone.replace(/\s/g, "").replace(/'/g, "\\'").replace(/"/g, '\\"')
      : "";

    const signatureHTML = `<table cellpadding="0" cellspacing="0" border="0" style="font-family: Arial, sans-serif; font-size: 14px; color: #214277; line-height: 1.6;">
    <tr>
      <td style="padding: 0;">
        <table cellpadding="0" cellspacing="0" border="0">
          <tr>
            <td style="vertical-align: top; padding-bottom: 0px;">
              <strong style="font-size: 18px; color: #214277;  font-weight: bold;">${name || "Your Name"}</strong>
              ${title ? `<div style="padding-top: 0px; padding-bottom: 8px; color: #214277; font-size: 16px; font-weight: 500;">${title}</div>` : ""}
              ${phone ? `<div style="padding-top: 0px; padding-bottom: 0px; color: #214277;">
                <img src="${phoneImageUrl}" alt="Phone" style="display: inline-block; vertical-align: middle; height: 14px; width: auto; margin-right: 6px;" /><a href="tel:${phone.replace(/\s/g, "")}" onclick="event.preventDefault(); navigator.clipboard.writeText('${phoneForJS}').then(() => alert('Phone number copied to clipboard!')).catch(() => alert('Failed to copy. Phone number: ${phoneForJS}'));" style="color: #214277; text-decoration: none; vertical-align: middle; cursor: pointer; font-weight: 500;">${phone}</a>
              </div>` : ""}
            </td>
            <td style="text-align: right; vertical-align: top; width: 40px; padding-left: 10px;">
              <img src="${angelImageUrl}" alt="Angel" style="height: 40px; width: 40px; max-height: 40px; max-width: 40px; display: block; object-fit: contain;" />
            </td>
          </tr>
          <tr>
            <td colspan="2" style="padding-bottom: 4px; color: #214277; font-weight: 500;">
              <img src="${locationImageUrl}" alt="Location" style="display: inline-block; vertical-align: middle; height: 14px; width: auto; margin-right: 6px;" />5 El Abbady st. - Roushdy - Alexandria \\ Egypt
            </td>
          </tr>
          <tr>
            <td colspan="2" style="padding-top: 8px; padding-bottom: 4px;">
              <img src="${logoImageUrl}" alt="Logo" style="display: inline-block; vertical-align: middle; height: auto; width: auto; max-height: 30px; margin-right: 12px;" />
              <a href="https://www.facebook.com/bdaiat/" target="_blank" rel="noopener noreferrer" style="display: inline-block; vertical-align: middle; margin-right: 4px;">
                <img src="${facebookImageUrl}" alt="Facebook" style="display: inline-block; vertical-align: middle; height: 28px; width: auto;" />
              </a>
              <a href="https://eg.linkedin.com/company/bdaiat" target="_blank" rel="noopener noreferrer" style="display: inline-block; vertical-align: middle; margin-right: 4px;">
                <img src="${linkedinImageUrl}" alt="LinkedIn" style="display: inline-block; vertical-align: middle; height: 28px; width: auto;" />
              </a>
              <a href="https://x.com/bdaiattech" target="_blank" rel="noopener noreferrer" style="display: inline-block; vertical-align: middle; margin-right: 4px;">
                <img src="${xImageUrl}" alt="X" style="display: inline-block; vertical-align: middle; height: 28px; width: auto;" />
              </a>
              <a href="https://bdaiat.com" target="_blank" rel="noopener noreferrer" style="display: inline-block; vertical-align: middle;">
                <img src="${webImageUrl}" alt="Web" style="display: inline-block; vertical-align: middle; height: 28px; width: auto;" />
              </a>
            </td>
          </tr>
          <tr>
            <td colspan="2" style="padding-top: 8px; padding-bottom: 4px; color: #214277; font-weight: 500;">
              Awarded by : <img src="${microsoftImageUrl}" alt="Microsoft" style="display: inline-block; vertical-align: middle; height: 28px; width: auto; margin-left: 8px; margin-right: 12px;" /><img src="${academyImageUrl}" alt="Academy" style="display: inline-block; vertical-align: middle; height: 45px; width: auto;" />
            </td>
          </tr>
          <tr>
            <td colspan="2" style="padding-top: 8px; padding-bottom: 4px;">
              <img src="${bannerImageUrl}" alt="Banner" style="display: block; height: auto; width: auto;" />
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>`;

    if (includeWrapper) {
      return `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
</head>
<body>
  ${signatureHTML}
</body>
</html>`;
    }

    return signatureHTML;
  };

  const copyToClipboard = async () => {
    const html = generateHTMLSignature(false);
    const plainText = `${formData.name || "Your Name"}\n${formData.title ? formData.title + "\n" : ""}${formData.phone ? "Phone: " + formData.phone : ""}`;

    try {
      if (typeof ClipboardItem !== "undefined") {
        const clipboardItem = new ClipboardItem({
          "text/html": new Blob([html], { type: "text/html" }),
          "text/plain": new Blob([plainText], { type: "text/plain" }),
        });
        await navigator.clipboard.write([clipboardItem]);
      } else {
        await navigator.clipboard.writeText(html);
      }
      alert("Signature copied! For Gmail: Go to Settings > General > Signature, then paste the HTML code there.");
    } catch (err) {
      console.error("Failed to copy:", err);
      try {
        await navigator.clipboard.writeText(html);
        alert("HTML copied! For Gmail: Go to Settings > General > Signature, then paste the HTML code there.");
      } catch (fallbackErr) {
        alert("Failed to copy. Please select and copy manually from the HTML code section below.");
      }
    }
  };

  if (!isAuthenticated) {
    return (
      <div className="sig-creator sig-creator--center">
        <div className="sig-creator__auth-card">
          <h1 className="sig-creator__title">Password Required</h1>

          <form onSubmit={handlePasswordSubmit} className="sig-creator__form">
            <div className="sig-creator__field">
              <label htmlFor="password" className="sig-creator__label">
                Enter Password
              </label>
              <div className="sig-creator__input-wrap">
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="sig-creator__input"
                  placeholder="Enter password"
                  autoFocus
                />
              </div>
            </div>

            {error && <div className="sig-creator__error">{error}</div>}

            <button type="submit" className="sig-creator__btn">
              Access Signature Creator
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="sig-creator">
      <div className="sig-creator__inner">
        <h1 className="sig-creator__page-title">Email Signature Creator</h1>

        <div className="sig-creator__grid">
          <div className="sig-creator__panel">
            <h2 className="sig-creator__panel-title">Enter Your Information</h2>
            <div className="sig-creator__fields">
              <div className="sig-creator__field">
                <label htmlFor="name" className="sig-creator__label">
                  Name
                </label>
                <div className="sig-creator__input-wrap">
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="sig-creator__input"
                    placeholder="John Doe"
                  />
                </div>
              </div>

              <div className="sig-creator__field">
                <label htmlFor="title" className="sig-creator__label">
                  Title
                </label>
                <div className="sig-creator__input-wrap">
                  <input
                    type="text"
                    id="title"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                    className="sig-creator__input"
                    placeholder="Software Engineer"
                  />
                </div>
              </div>

              <div className="sig-creator__field">
                <label htmlFor="phone" className="sig-creator__label">
                  Phone Number
                </label>
                <div className="sig-creator__input-wrap">
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="sig-creator__input"
                    placeholder="+1 (555) 123-4567"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="sig-creator__panel">
            <h2 className="sig-creator__panel-title">Signature Preview</h2>

            <div className="sig-creator__preview">
              <div
                dangerouslySetInnerHTML={{
                  __html: generateHTMLSignature(false, { forEmail: false }),
                }}
              />
            </div>

            <button
              onClick={copyToClipboard}
              className="sig-creator__btn sig-creator__btn--mb"
            >
              Copy HTML to Clipboard
            </button>

            <div className="sig-creator__gmail">
              <h3>How to add to Gmail:</h3>
              <ol>
                <li>Go to Gmail Settings (gear icon → See all settings)</li>
                <li>Click "General" tab</li>
                <li>Scroll to "Signature" section</li>
                <li>Click "Create new" or edit existing signature</li>
                <li>Click the formatting toolbar icon (looks like "&lt;/&gt;") to switch to HTML mode</li>
                <li>Paste the HTML code from below</li>
                <li>Save changes</li>
              </ol>
            </div>

            <div className="sig-creator__code-wrap">
              <h3>HTML Code (for Gmail)</h3>
              <div className="sig-creator__code">
                <pre>{generateHTMLSignature(false)}</pre>
              </div>
              <button
                className="sig-creator__link-btn"
                onClick={() => {
                  const code = generateHTMLSignature(false);
                  navigator.clipboard.writeText(code).then(() => {
                    alert("HTML code copied!");
                  });
                }}
              >
                Copy HTML code only
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
